import { render, staticRenderFns } from "./SimpleLessonCard.vue?vue&type=template&id=a0e3ae72&scoped=true&"
import script from "./SimpleLessonCard.vue?vue&type=script&lang=js&"
export * from "./SimpleLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLessonCard.vue?vue&type=style&index=0&id=a0e3ae72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e3ae72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
